import { UtilizationBar } from '../../../components/Shared/UtilizationBar';
import type { ObjectAggregate } from '../../../types/lists';

interface ObjectPlannedProps {
  agg: ObjectAggregate | undefined;
  /** Object colour (`getObjectColors(...).color`). */
  color: string;
}

/**
 * Share of this week's due hours that is planned (FAFD-56). More planned than due is a
 * hint (amber), not a conflict; objects without due work show "—".
 */
export function PlannedValue({ agg, color }: ObjectPlannedProps) {
  const planned = agg?.planned ?? null;
  if (planned === null) {
    return <span className="font-mono-num text-[11px] font-medium text-slate-400">—</span>;
  }
  const over = planned > 1;
  return (
    <span
      className={`font-mono-num text-[11px] font-medium ${over ? 'text-amber-500' : ''}`}
      // harness-ignore FE_STYLE_INLINE why: object colour is a runtime value from getObjectColors
      style={over ? undefined : { color }}
    >
      {Math.round(planned * 100)}%
    </span>
  );
}

export function PlannedBar({ agg, color, className = '' }: ObjectPlannedProps & { className?: string }) {
  return <UtilizationBar planned={agg?.planned ?? 0} target={1} color={color} className={className} />;
}
